import { render } from "./AiFeedbackModal.vue?vue&type=template&id=71785afc"
import script from "./AiFeedbackModal.vue?vue&type=script&lang=js"
export * from "./AiFeedbackModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__